<template>
  <div id="outstream" style="background-color:white;" v-show="!loaded">
    <img
      :src="isamnet"
      style="width:100%"
      @load="onLoad"
    />
    <div id="utsvideoad"></div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/outstream/bg2.png"
      style="width:100%"
      @load="onLoad"
    />
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixOutstream from "@/components/mixins/outstream.js";
export default {
  data() {
    return {
      loaded: 2,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if(domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg1.png'
      } else {
        isAmnet += '/outstream/bg1.png'
      }
      return isAmnet
    }
  },
  async mounted() {
    await this.$nextTick();
    this.creative.vast_xml = this.removeTrackingEvent(this.creative.vast_xml);
    const target = document.getElementById("utsvideoad");
    this.addPlayer(target, 640, 360);
  },
  mixins: [mixPreview, mixOutstream],
  methods: {
    messageHandler(e) {
      const frame = document.querySelector("iframe");
      switch (e.data.type) {
        case "close":
          //error, noAd or close button
          this.videoIO.unobserve(this.video_div);
          frame.style.display = "none";
          break;
        case "ready":
          this.initialAd(this.creative.vast_xml);
          this.videoIO.observe(this.video_div);
          break;
        case "Loaded":
          frame.style.display = "block";
          this.onVideoPlay();
          break
        case "Start":
          if (!this.isVideoViewable) this.onVideoPause();
          this.showToolBar();
          break;
        case "error":
          this.$notify.error({
            title: "Error",
            message: e.data.error,
            position: "bottom-right",
            offset: 20,
          });
        default:
          break;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
#utsvideoad
  margin: auto
  width: 640px
</style>
